// https://www.geeksforgeeks.org/how-to-detect-touch-screen-device-using-javascript/
import { useEffect, useState } from 'react';

export function useIsTouch() {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    setIsTouch('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }, []);

  return isTouch;
}
